import { useLang } from "@/i18n";
import { ArrowRight } from "lucide-react";

export default function TopBar() {
  const { t } = useLang();
  return (
    <div className="fixed top-0 inset-x-0 z-50 h-9 bg-[#003087] flex items-center justify-center px-4" data-testid="announcement-topbar">
      <a href="#prezzi" className="flex items-center gap-2 text-white text-[11px] sm:text-xs font-semibold tracking-wide hover:opacity-90 transition-opacity duration-200">
        <span className="hidden md:inline">{t("topbar.text")}</span>
        <span className="md:hidden">{t("topbar.mobile")}</span>
        <span className="hidden sm:inline-flex items-center gap-1 text-[#9BDDF7] font-bold">
          {t("topbar.cta")} <ArrowRight size={12} />
        </span>
      </a>
      <span className="absolute right-4 hidden lg:inline text-[10px] font-bold uppercase tracking-[0.2em] text-[#9BDDF7]">{t("topbar.badge")}</span>
    </div>
  );
}
